const s = {
  // AUTH
  authPage: {
    minHeight: '100vh', display: 'flex',
    alignItems: 'center', justifyContent: 'center',
    backgroundColor: '#1D9E75', padding: 20,
  },
  authCard: {
    backgroundColor: '#FFF', borderRadius: 20, padding: 40,
    maxWidth: 420, width: '100%', textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
  },
  authTitle: { fontSize: 28, fontWeight: 800, marginBottom: 8, color: '#1A1A1A' },
  authSub: { color: '#888', fontSize: 14, marginBottom: 32, lineHeight: 1.5 },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 },
  fieldGroup: { marginBottom: 14 },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#444', marginBottom: 6 },
  input: {
    width: '100%', padding: '11px 14px', borderRadius: 10,
    border: '1px solid #E5E7EB', fontSize: 14, color: '#222',
    backgroundColor: '#F7F8FA', outline: 'none', boxSizing: 'border-box',
  },
  select: {
    width: '100%', padding: '11px 14px', borderRadius: 10,
    border: '1px solid #E5E7EB', fontSize: 14, color: '#222',
    backgroundColor: '#F7F8FA', outline: 'none', boxSizing: 'border-box',
    cursor: 'pointer',
  },
  loginBtn: {
    width: '100%', padding: '14px', backgroundColor: '#1D9E75',
    color: '#FFF', border: 'none', borderRadius: 12,
    fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8,
  },
  infoBox: {
    backgroundColor: '#E8F8F2', borderRadius: 10, padding: 14,
    border: '1px solid #B2DFD0', marginTop: 8,
  },
  infoText: { fontSize: 13, color: '#1D6B52', margin: 0 },
  backBtn: {
    background: 'none', border: 'none', color: '#1D9E75',
    fontSize: 14, cursor: 'pointer', padding: '4px 0', marginBottom: 16,
    fontWeight: 600, display: 'block',
  },
  priceHint: { fontSize: 12, color: '#1D9E75', margin: '4px 0 0', fontWeight: 500 },
  excelHint: {
    backgroundColor: '#EFF6FF', borderRadius: 8, padding: 12,
    marginBottom: 16, border: '1px solid #BFDBFE',
  },

  // DASHBOARD
  dashboard: { minHeight: '100vh', backgroundColor: '#F7F8FA' },
  navbar: {
    backgroundColor: '#1D9E75', padding: '0 24px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    height: 64, position: 'sticky', top: 0, zIndex: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  navLeft: { display: 'flex', alignItems: 'center', gap: 10 },
  navLogo: { fontSize: 26 },
  navTitle: { fontSize: 18, fontWeight: 700, color: '#FFF' },
  navRight: { display: 'flex', alignItems: 'center', gap: 12 },
  navUser: { fontSize: 14, color: '#A8EDCF', fontWeight: 500 },
  guideBtn: {
    padding: '6px 14px', backgroundColor: 'rgba(255,255,255,0.15)',
    color: '#FFF', border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 500,
  },
  logoutBtn: {
    padding: '6px 14px', backgroundColor: 'rgba(255,255,255,0.15)',
    color: '#FFF', border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: 8, cursor: 'pointer', fontSize: 13,
  },
  content: { maxWidth: 1200, margin: '0 auto', padding: '24px 20px' },
  dashTabs: {
    display: 'flex', gap: 4, marginBottom: 24,
    backgroundColor: '#FFF', borderRadius: 12, padding: 6,
    border: '1px solid #E5E7EB', flexWrap: 'wrap',
  },
  dashTab: {
    padding: '9px 16px', borderRadius: 8, border: 'none',
    cursor: 'pointer', fontSize: 13, fontWeight: 500,
    backgroundColor: 'transparent', color: '#888',
    whiteSpace: 'nowrap',
  },
  dashTabActive: {
    backgroundColor: '#1D9E75', color: '#FFF', fontWeight: 700,
  },

  // STATS
  statsRow: {
    display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)',
    gap: 12, marginBottom: 20,
  },
  statCard: {
    backgroundColor: '#FFF', borderRadius: 12, padding: 16,
    textAlign: 'center', border: '1px solid #E5E7EB',
  },
  statValue: { fontSize: 28, fontWeight: 800, margin: '0 0 4px', color: '#1A1A1A' },
  statLabel: { fontSize: 12, color: '#888', margin: 0 },

  // FILTERS
  filterRow: {
    display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap',
  },
  filterBtn: {
    padding: '7px 14px', borderRadius: 20, border: '1px solid #E5E7EB',
    backgroundColor: '#FFF', cursor: 'pointer', fontSize: 13,
    fontWeight: 500, color: '#555', display: 'flex', alignItems: 'center', gap: 6,
  },
  filterBtnActive: {
    backgroundColor: '#1D9E75', color: '#FFF', borderColor: '#1D9E75', fontWeight: 700,
  },
  filterCount: {
    backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 20,
    padding: '1px 8px', fontSize: 11, fontWeight: 700,
  },

  // ORDERS
  ordersGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: 16,
  },
  orderCard: {
    backgroundColor: '#FFF', borderRadius: 12, padding: 18,
    border: '1px solid #E5E7EB',
    boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
  },
  orderCardHeader: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'flex-start', marginBottom: 14,
  },
  orderId: { fontSize: 16, fontWeight: 700, margin: '0 0 2px', color: '#1A1A1A' },
  orderTime: { fontSize: 12, color: '#888', margin: 0 },
  statusBadge: {
    padding: '4px 10px', borderRadius: 20,
    fontSize: 12, fontWeight: 600,
  },
  orderCustomer: { marginBottom: 10 },
  customerName: { fontSize: 15, fontWeight: 600, margin: '0 0 2px', color: '#1A1A1A' },
  customerEmail: { fontSize: 12, color: '#888', margin: '0 0 4px' },
  customerPhone: {
    fontSize: 12, color: '#1D9E75', margin: 0,
    display: 'flex', alignItems: 'center', gap: 6,
    textDecoration: 'none', fontWeight: 500,
  },
  callBtn: {
    backgroundColor: '#E8F8F2', borderRadius: 6,
    padding: '2px 8px', fontSize: 11, fontWeight: 600,
    color: '#1D6B52', marginLeft: 6,
  },
  orderItems: { marginBottom: 10 },
  orderItem: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', padding: '4px 0',
    borderBottom: '0.5px solid #F3F4F6',
  },
  itemName: { fontSize: 13, color: '#333', fontWeight: 500 },
  itemDetail: { fontSize: 12, color: '#888' },
  deliveryAddress: {
    backgroundColor: '#F7F8FA', borderRadius: 8,
    padding: '8px 10px', marginBottom: 12,
    border: '0.5px solid #E5E7EB',
  },
  orderFooter: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', marginTop: 12, paddingTop: 12,
    borderTop: '0.5px solid #F3F4F6',
  },
  orderTotal: { display: 'flex', alignItems: 'center', gap: 8 },
  totalLabel: { fontSize: 13, color: '#888' },
  totalValue: { fontSize: 18, fontWeight: 700, color: '#1D9E75' },
  actionRow: { display: 'flex', gap: 8, alignItems: 'center' },
  statusSelect: {
    padding: '7px 10px', borderRadius: 8, border: '1px solid #E5E7EB',
    fontSize: 13, backgroundColor: '#F7F8FA', cursor: 'pointer', outline: 'none',
  },
  updateBtn: {
    padding: '8px 16px', backgroundColor: '#1D9E75', color: '#FFF',
    border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13,
  },

  // INVENTORY
  tabHeader: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10,
  },
  tabTitle: { fontSize: 18, fontWeight: 700, margin: 0 },
  addBtn: {
    padding: '10px 20px', backgroundColor: '#1D9E75', color: '#FFF',
    border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 14,
  },
  importBtn: {
    padding: '10px 18px', backgroundColor: '#3B82F6', color: '#FFF',
    border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 600,
    fontSize: 13, display: 'inline-block',
  },
  formCard: {
    backgroundColor: '#FFF', borderRadius: 12, padding: 24,
    marginBottom: 20, border: '1px solid #E5E7EB',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
  formTitle: { fontSize: 16, fontWeight: 700, marginBottom: 16, color: '#1A1A1A' },
  medicinesGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14,
  },
  medCard: {
    backgroundColor: '#FFF', borderRadius: 12, padding: 16,
    border: '1px solid #E5E7EB',
  },
  medCardHeader: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'flex-start', marginBottom: 10,
  },
  medName: { fontSize: 15, fontWeight: 700, margin: '0 0 2px', color: '#1A1A1A' },
  medCategory: { fontSize: 12, color: '#888', margin: 0 },
  stockBadge: {
    padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
  },
  medPrices: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    backgroundColor: '#F7F8FA', borderRadius: 8, padding: 10, marginBottom: 10,
  },
  medPriceLabel: { fontSize: 11, color: '#888', margin: '0 0 2px' },
  medPrice: { fontSize: 16, fontWeight: 700, margin: 0, color: '#1A1A1A' },
  commissionArrow: { textAlign: 'center' },
  commissionText: { fontSize: 11, color: '#1D9E75', fontWeight: 700, margin: 0 },
  commissionArrowText: { fontSize: 18, color: '#1D9E75', margin: 0 },
  medFooter: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', flexWrap: 'wrap', gap: 8,
  },
  medQty: { fontSize: 13, color: '#555', margin: 0 },
  editBtn: {
    padding: '5px 12px', backgroundColor: '#EFF6FF', color: '#1D4ED8',
    border: '1px solid #BFDBFE', borderRadius: 7,
    cursor: 'pointer', fontSize: 12, fontWeight: 600,
  },
  stockToggleBtn: {
    padding: '5px 12px', border: 'none',
    borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600,
  },

  // STATES
  loadingState: {
    textAlign: 'center', padding: 60, color: '#888', fontSize: 15,
  },
  emptyState: {
    textAlign: 'center', padding: 60, backgroundColor: '#FFF',
    borderRadius: 12, border: '1px solid #E5E7EB',
  },
};

export default s;